import { makeStyles } from "@material-ui/styles";

const gameHeaderStyles = makeStyles((theme) => ({
	root: {
		height: 86,
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1)
	},
	title: {
		color: theme.palette.gameMode.primary,
		marginBottom: theme.spacing(1),
		[theme.breakpoints.only("xs")]: {
			paddingLeft: theme.spacing(6)
		}
	},
	description: {
		color: theme.palette.gameMode.primary
	}
}));

export default gameHeaderStyles;
